import { ConfigProvider, useConfigState } from './config/ConfigContext';
import AppShell from './shell/AppShell';
import EmptyState from './components/EmptyState';

function AppInner() {
  const { config, error, loading } = useConfigState();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'var(--font-sans)', color: 'var(--fg-3)' }}>
        Loading…
      </div>
    );
  }

  if (error || !config) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', padding: 'var(--sp-8)' }}>
        <EmptyState variant="fetch-failed" errorCode={error ?? 'CONFIG_UNKNOWN'} />
      </div>
    );
  }

  return <AppShell />;
}

export default function App() {
  return (
    <ConfigProvider>
      <AppInner />
    </ConfigProvider>
  );
}
